import React, { useState } from 'react';
import Sidebar from './Sidebar';
import { brand } from '../../config/brand';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    return localStorage.getItem('sidebar-collapsed') === 'true';
  });

  const handleCollapse = () => {
    const next = !sidebarCollapsed;
    setSidebarCollapsed(next);
    localStorage.setItem('sidebar-collapsed', String(next));
  };

  return (
    <div className={`layout ${sidebarCollapsed ? 'sidebar-is-collapsed' : ''}`}>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        collapsed={sidebarCollapsed}
        onToggleCollapse={handleCollapse}
      />
      <div className={`main-content ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <header className="main-header">
          <button
            className="sidebar-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-label="Toggle navigation"
            aria-expanded={sidebarOpen}
          >
            ☰
          </button>
          {brand.logo && (
            <img
              src={brand.logo}
              alt={brand.appName}
              style={{ width: brand.logoSize.width, height: brand.logoSize.height }}
            />
          )}
          <h1>{brand.appName}</h1>
        </header>
        <main id="main-content" className="main-body" aria-label="Main content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
